import { render, staticRenderFns } from "./ownerDetailHis.vue?vue&type=template&id=6658ed99&scoped=true"
import script from "./ownerDetailHis.vue?vue&type=script&lang=js"
export * from "./ownerDetailHis.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailHis.vue?vue&type=style&index=0&id=6658ed99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6658ed99",
  null
  
)

export default component.exports